import type { StaticImageData } from "next/image";
import IconServices5 from "~/public/assets/services/apps/icon-menu-apps-3d.png";
import IconServices1 from "~/public/assets/services/icon-cursor-screen-3d.png";
import IconServices3 from "~/public/assets/services/icon-dev-3d.png";
// import IconServices2 from "~/public/assets/services/icon-search-3d.png"; // Product Discovery (oculto)
import IconServices4 from "~/public/assets/services/icon-star-ia-3d.png";

export type ServiceItem = {
	icon: StaticImageData | string;
	title: string;
	description: string;
	linkLabel?: string;
	linkHref?: string;
};

export const defaultServices: ServiceItem[] = [
	{
		icon: IconServices1,
		title: "UX & UI \nDesign",
		description: "Criamos interfaces intuitivas e \norientadas a resultados.",
		linkHref: "/servicos/ux-ui",
	},
	// TODO: Product Discovery — oculto do bloco de serviços a pedido; a página
	// segue publicada em /servicos/product-discovery. Reativar removendo o
	// comentário abaixo (e o do import IconServices2).
	// {
	// 	icon: IconServices2,
	// 	title: "Product \nDiscovery",
	// 	description: "Definimos o caminho certo para o produto.",
	// 	linkHref: "/servicos/product-discovery",
	// },
	{
		icon: IconServices3,
		title: "Desenvolvimento\nde sistemas",
		description: "Software sob medida, seguro e escalável",
		linkHref: "/servicos/desenvolvimento-de-software",
	},
	{
		icon: IconServices5,
		title: "Desenvolvimento\nde aplicativos",
		description: "Apps iOS e Android da ideia à loja.",
		linkHref: "/servicos/desenvolvimento-de-aplicativos",
	},
	{
		icon: IconServices4,
		title: "IA para \nnegócios digitais",
		description: "IA acelerando, especialistas decidindo.",
		linkHref: "/servicos/ia-first",
	},
];
